import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { MINT_MIST } from '../../constants/brandSurfaces';

const blue = '#0d4efe';
const teal = '#01ebb2';
const ink = '#1a1a2e';
const muted = '#5a6478';

export const Panel = styled('section')({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 5fr) minmax(0, 6fr)',
  alignItems: 'center',
  gap: 40,
  marginTop: 36,
  padding: '44px 48px',
  borderRadius: 24,
  border: '1px solid rgba(26, 26, 46, 0.06)',
  background: MINT_MIST,
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
    gap: 24,
    padding: '32px 28px',
  },
  '@media (max-width: 600px)': {
    marginTop: 20,
    padding: '26px 16px',
    borderRadius: 16,
  },
});

export const Intro = styled('div')({
  textAlign: 'left',
});

export const Eyebrow = styled('p')({
  margin: '0 0 8px',
  fontSize: '0.95rem',
  fontWeight: 700,
  color: blue,
});

export const Title = styled('h2')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.75rem',
  fontWeight: 700,
  lineHeight: 1.2,
  letterSpacing: '-0.02em',
  color: ink,
  margin: '0 0 10px',
  '@media (max-width: 600px)': {
    fontSize: '1.4rem',
  },
});

export const IntroText = styled('p')({
  fontSize: '1rem',
  lineHeight: 1.6,
  color: muted,
  margin: '0 0 16px',
  maxWidth: 440,
});

export const CityList = styled('ul')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  listStyle: 'none',
  padding: 0,
  margin: '0 0 24px',
  '& li': {
    padding: '5px 12px',
    borderRadius: 999,
    fontSize: '0.86rem',
    fontWeight: 600,
    color: ink,
    background: '#ffffff',
    border: '1px solid rgba(26, 26, 46, 0.08)',
  },
});

export const PrimaryCta = styled(Button)({
  textTransform: 'none',
  borderRadius: 10,
  padding: '11px 26px',
  fontSize: '1rem',
  fontWeight: 700,
  color: '#ffffff',
  background: `linear-gradient(90deg, ${teal} 0%, ${blue} 100%)`,
  boxShadow: '0 4px 14px rgba(13, 78, 254, 0.35)',
  '&:hover': {
    color: '#ffffff',
    background: `linear-gradient(90deg, ${teal} 0%, ${blue} 100%)`,
    filter: 'brightness(1.05)',
    boxShadow: '0 6px 18px rgba(13, 78, 254, 0.4)',
  },
});

export const StepList = styled('ol')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const Step = styled('li')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  padding: '16px 18px',
  borderRadius: 16,
  background: '#ffffff',
  border: '1px solid rgba(26, 26, 46, 0.06)',
  boxShadow: '0 4px 16px rgba(26, 26, 46, 0.05)',
  textAlign: 'left',
});

export const StepIcon = styled('span')({
  flex: '0 0 auto',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 44,
  height: 44,
  borderRadius: '50%',
  color: blue,
  background: 'rgba(1, 235, 178, 0.18)',
  '& svg': { fontSize: 22 },
});

export const StepTitle = styled('h3')({
  fontSize: '1.02rem',
  fontWeight: 700,
  color: ink,
  margin: '0 0 2px',
});

export const StepText = styled('p')({
  fontSize: '0.94rem',
  lineHeight: 1.5,
  color: muted,
  margin: 0,
});
